export default "__VITE_ASSET__DAQB41TE__"